// Generated by scripts/generate-public-surface.ts. Do not edit.

import type { CountryValidator } from "../../types";

import { createValidator } from "#stdnum-runtime";

const vat: CountryValidator<"FI"> = createValidator(
  "fi.vat",
  72,
);

export default vat;
export const compact = vat.compact;
export const format = vat.format;
export const validate = vat.validate;
export const generate = (): string =>
  vat.generate?.() ??
  (() => {
    throw new Error(
      "Validator fi.vat cannot generate values",
    );
  })();
